import script from "./ContentWidgetPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentWidgetPopup.vue?vue&type=script&setup=true&lang=js"

import "./ContentWidgetPopup.vue?vue&type=style&index=0&id=b4988640&lang=scss"

const __exports__ = script;

export default __exports__